import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  UpsertRateConfigPayload,
  listRateConfigs,
  upsertRateConfig,
} from "../services/rateConfigs";

import { useSessionUser } from "./useAuth";

export const useRateConfigs = () => {
  const { data: sessionUser } = useSessionUser();
  return useQuery({
    enabled: !!sessionUser?.currentWorkspaceId,
    queryFn: listRateConfigs,
    queryKey: ["rateConfigs", sessionUser?.currentWorkspaceId || ""],
    refetchOnWindowFocus: false,
  });
};

export const useUpsertRateConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      connectedWorkspaceId,
      payload,
    }: {
      connectedWorkspaceId: string;
      payload: UpsertRateConfigPayload;
    }) => upsertRateConfig(connectedWorkspaceId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["rateConfigs"] });
    },
  });
};
